import { useState, useEffect } from "react";
import BallLoader from "../components/shared/BallLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import axios from "axios";
import { API } from "../contexts/AuthContext";
import { useTranslation } from "@/i18n";

export const ConfirmEmailChangePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid link. No token provided.");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/confirm-email-change`, { token });
        setStatus("success");
        setMessage(res.data.message || "Email changed successfully!");
        // Force logout - they need to log in with new email
        localStorage.removeItem("token");
      } catch (err) {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Confirmation failed.");
      }
    })();
  }, [searchParams]);

  return (
    <div className="app-container px-8 flex flex-col justify-center min-h-screen">
      <div className="text-center max-w-sm mx-auto">
        <h1 className="text-3xl font-bold mb-8">Xelanti</h1>
        
        {status === "verifying" && (
          <>
            <BallLoader size={48} className="mb-4" />
            <p className="text-gray-600 dark:text-gray-300">{t('emailChange.confirming')}</p>
          </>
        )}
        
        {status === "success" && (
          <>
            <CheckCircle size={64} className="mx-auto mb-4 text-green-500" />
            <h2 className="text-2xl font-bold mb-3">{t('emailChange.emailChanged')}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-8">{message}</p>
            <button onClick={() => navigate("/login")} className="clean-btn-primary w-full">
              {t('emailChange.signInNewEmail')}
            </button>
          </>
        )}
        
        {status === "error" && (
          <>
            <XCircle size={64} className="mx-auto mb-4 text-red-500" />
            <h2 className="text-2xl font-bold mb-3">{t('emailChange.couldntConfirm')}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-8">{message}</p>
            <button onClick={() => navigate("/login")} className="clean-btn-primary w-full">
              {t('verify.backToSignIn')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
